var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "fields",
      attrs: { "aria-role": "menu", "mobile-modal": false },
    },
    [
      _c(
        "a",
        {
          staticClass: "button is-white",
          attrs: { slot: "trigger", role: "button" },
          slot: "trigger",
        },
        [
          _c(
            "span",
            { staticClass: "icon" },
            [_c("Icon", { attrs: { name: "TableConfig" } })],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("fields")))]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "head" }, [
        _vm._v(_vm._s(_vm.$t("showFields")) + ":"),
      ]),
      _vm._v(" "),
      _vm._l(_vm.defaultFields, function (field, index) {
        return _c(
          "b-dropdown-item",
          { key: index, attrs: { "aria-role": "menu-item", custom: "" } },
          [
            _c("chooseInput", {
              attrs: { type: "CHECKBOX", label: field.label },
              on: {
                input: function ($event) {
                  return _vm.updateFields()
                },
              },
              model: {
                value: field._visible,
                callback: function ($$v) {
                  _vm.$set(field, "_visible", $$v)
                },
                expression: "field._visible",
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }